import '../jquery'

let ready_legacy_contact_import;

ready_legacy_contact_import = function() {
  let changeGroupType, csvColSepFieldsDisplay;
  $("body").on("change", "#add_to_group_fields .custom-radio", function() {
    var groupType;
    groupType = $(this).find('input:checked').val();
    return changeGroupType(groupType);
  });
  $("body").on("change", "#contact_import_file", function() {
    let extension;
    extension = $(this).val().split('.').pop().toLowerCase();
    return csvColSepFieldsDisplay(extension);
  });
  $("body").on("change", "#csv_col_sep_fields input[type='radio']", function() {
    let sepType;
    sepType = $("#csv_col_sep_fields").find('input:checked').val();
    if (sepType === 'other') {
      $('#contact_import_csv_col_sep').prop('readonly', false);
      return $('#contact_import_csv_col_sep').val('');
    } else {
      $('#contact_import_csv_col_sep').prop('readonly', true);
      return $('#contact_import_csv_col_sep').val(sepType);
    }
  });
  changeGroupType = function(groupType) {
    if (groupType === "new") {
      $('#new_group_field').show();
      $('#existing_group_field').hide();
      return $('#existing_group_field select').selectpicker('val', null);
    } else {
      $('#new_group_field').hide();
      $('#existing_group_field').show();
      return $('#new_group_field input').val('');
    }
  };
  return csvColSepFieldsDisplay = function(extension) {
    if (extension === 'csv') {
      return $('#csv_col_sep_fields').show();
    } else {
      $('#csv_col_sep_fields').hide();
      $('#contact_import_csv_col_sep').val('');
      return $('#csv_col_sep_fields').find('input:checked').prop('checked', false);
    }
  };
};

$(document).ready(ready_legacy_contact_import);

$(document).on('turbo:load', ready_legacy_contact_import);
